import dayjs from 'dayjs'

import { ITripListFilters } from 'src/api/types/trips'
import { SpeedUnit, DistanceUnit } from 'src/api/types/units'
import { getTranslation } from 'src/commons/i18n'
import { IDockedStation, IMapSettings } from 'src/commons/map/types'
import { getSatelliteFromStorage } from 'src/commons/map/utils'
import { getTemporalRange } from 'src/commons/temporalHelpers'

import {
  DEFAULT_MIN_DURATION,
  DEFAULT_MAX_DURATION,
  DEFAULT_MIN_TRIPS_PER_STREET,
  DEFAULT_MAX_TRIPS_PER_STREET,
  DEFAULT_MIN_SPEED,
  DEFAULT_MAX_SPEED,
  DEFAULT_MIN_DISTANCE,
  DEFAULT_MAX_DISTANCE,
} from './constants'

// This one is being used for Trip List and Heatmap only
export function getInitialFilters(
  layer: string,
  speedUnit?: SpeedUnit,
  distanceUnit?: DistanceUnit
): IMapSettings & ITripListFilters & IDockedStation {
  const initialFilters: IMapSettings & ITripListFilters & IDockedStation = {
    id: '',
    vehicle_type: [],
    provider: [],
    duration: [DEFAULT_MIN_DURATION, DEFAULT_MAX_DURATION],
    dateStartRange: getTemporalRange({ days: 2 }, true),
    dateEndRange: { from: undefined, to: undefined },
    dayOfWeek: [],
    origins: [],
    destinations: [],
    layer,
    tripsPerStreet: [DEFAULT_MIN_TRIPS_PER_STREET, DEFAULT_MAX_TRIPS_PER_STREET],
    stopsLayers: [],
    satellite: getSatelliteFromStorage() ?? '0',
    dockedStationLayers: [],
  }
  if (!!speedUnit) {
    initialFilters.speed = [DEFAULT_MIN_SPEED[speedUnit], DEFAULT_MAX_SPEED[speedUnit]]
  }
  if (!!distanceUnit) {
    initialFilters.distance = [DEFAULT_MIN_DISTANCE[distanceUnit], DEFAULT_MAX_DISTANCE[distanceUnit]]
  }
  return initialFilters
}

export const INITIAL_FACETS = {
  provider_id: {},
  propulsion_type: {},
  vehicle_type: {},
  duration: {},
  distance: {},
  speed: {},
}

export function formatDuration(durationInMinutes: number | string, withSeconds = false): string {
  const { t } = getTranslation()
  if (typeof durationInMinutes === 'string') {
    durationInMinutes = parseInt(durationInMinutes, 10)
  }
  const duration = dayjs.duration(durationInMinutes, 'minutes')
  const hours = duration.hours()
  const seconds = duration.seconds()
  const minutes = seconds <= 30 || !withSeconds ? duration.minutes() : duration.minutes() + 1

  // For anything above hours to be displayed as days,
  // we have to compute the remainder as days :
  duration.subtract(hours, 'hours')
  duration.subtract(minutes, 'minutes')
  const days = Math.round(duration.asDays())

  const stringDuration = []
  if (days > 0) {
    stringDuration.push(`${days} ${t('duration.day')}`)
  }
  if (hours > 0) {
    stringDuration.push(`${hours} ${t('duration.hour')}`)
  }
  if (minutes > 0) {
    stringDuration.push(`${minutes} ${t('duration.minute')}`)
  }
  if (stringDuration.length === 0) {
    stringDuration.push(`0 ${t('duration.minute')}`)
  }
  if (withSeconds && seconds > 0) {
    stringDuration.push(`${seconds} ${t('duration.second')}`)
  }

  return stringDuration.join(' ')
}
